/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import swal from 'sweetalert2';

const warningMessage = window.APP.context.email_link_warning.message;

function shouldInterceptClick(url) {
  if (!url) {
    return false;
  }

  if (url.indexOf('mailto') === 0) {
    return true;
  }

  return false;
}

function warnOnEmailLinks() {
  $(document).on('click', 'a', (ev) => {
    const url = $(ev.currentTarget).attr('href');

    if (!shouldInterceptClick(url)) {
      return true;
    }

    ev.preventDefault();

    // SweetAlert2 does not support IE10.
    if (navigator.userAgent.indexOf('MSIE 10.0') !== -1) {
      if (window.confirm(warningMessage)) {
        window.location = url;
      }
    } else {
      swal({
        text: warningMessage,
        width: '24em',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#cacaca',
        confirmButtonText: 'Continue',
        animation: false,
        onOpen() {
          swal.getContent().style.fontSize = '.9rem';
        },
      }).then((result) => {
        if ('value' in result && result.value) {
          window.location = url;
        }
      });
    }
  });
}

// eslint-disable-next-line import/prefer-default-export
export { warnOnEmailLinks };

